import React from "react";
import cx from "classnames";
import s from "./detailInfo.scss";

export default function DetailInfo({ className, warning, error, label, info, inLine }) {
  return (
    <div
      className={cx(className, s.detailInfo, {
        [s.inLine]: inLine,
        [s.warning]: warning,
        [s.error]: error,
      })}
    >
      <label className={s.labelDetail}>{label}</label>
      <div className={s.dataDetail}>{info}</div>
    </div>
  );
}
